import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "var(--bw-bg-primary)" }}>
        <div className="label-overline">Loading…</div>
      </div>
    );
  }
  if (!user || !user.id) return <Navigate to="/login" replace />;
  return children;
}
